<template>
    <div class="users_filter">
        <BModal id="users_filter" v-bind:no-close-on-backdrop=true
                 dialogClass="modal-dialog-left modal-lg"
                 bodyClass="p-0"
                 :no-footer=true
                 :no-header=true
                 v-model="show" size="xl"
        >
            <div >
                <div id="panel_user_list" class="panel mb-0">
                    <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0 pt-2">
                        <h2>
                            Вибір <span class="fw-300">користувачів</span>
                        </h2>

                        <div class="panel-toolbar pr-3 mr-3 align-self-end">
                            <ul id="demo_panel-tabs" class="nav nav-tabs border-bottom-0" >
                                <li class="nav-item cursor-pointer" v-on:click="setTab(0)">
                                    <a class="nav-link " :class="{'active' : tabIndex === 0}" >По Регіону</a>
                                </li>

                                <li class="nav-item cursor-pointer" v-on:click="setTab(1)">
                                    <a class="nav-link" :class="{'active' : tabIndex === 1}">Пошук</a>
                                </li>
                            </ul>
                            <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                                <i class="fal fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="panel-container show">
                        <div class="panel-content">
                            <region v-if="tabIndex === 0"></region>
                            <search v-if="tabIndex === 1"></search>
                        </div>
                    </div>
                    <div class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-right w-100 position-absolute pos-bottom">
                        <button class="btn btn-lg btn-outline-primary waves-effect waves-themed mr-3 "  type="button"  @click.prevent="close_filter()">
                            <span  class="fal fa-check mr-1"></span>
                            Додати
                        </button>

                        <BButton size="xl" variant="outline-warning" @click.prevent="close()"  class="btn btn-lg  waves-effect waves-themed mr-3">
                          <i class="fal fa-times mr-1"></i>
                          Закрити
                        </BButton>
                    </div>
                </div>
            </div>
            

        </BModal>
    </div>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    const {mapFields} = createHelpers({
        getterType: 'users_filter/getUfilterField',
        mutationType: 'users_filter/updateUfilterField',
    });


    import region from './region.vue';
    import organization from './organization.vue';
    import search from './search.vue';
    
    
    import {
        BButton,
        BButtonGroup,
        BModal,
        BSpinner
    } from 'bootstrap-vue-next';

    export default {
        name: "users_filter",

        components : {
            region,
            organization,
            search,
            BButton,
            BModal,
            BSpinner
        },

        data() {
          return  {
              show : false,
              show_action : false,
              tabIndex: 0,
              uniq_call : '',
          }
        },
        
        created() {
            this.$store.dispatch('users_filter/SET_ACTIVE_EXCLUDE', []);

          //  EventBus.$off('check_list');
            EventBus.$on('load_users_filter', e => {
                console.log(e);
                if(e !== undefined) {
                    this.$store.dispatch('users_filter/SET_ACTIVE_USERS_LIST', []);

                    if (this.obj_to_null(e.exclude)) {
                        this.$store.dispatch('users_filter/SET_ACTIVE_EXCLUDE', e.exclude);
                    }

                    if (this.obj_to_null(e.active)) {
                        this.$store.dispatch('users_filter/SET_ACTIVE_USERS_LIST', e.active);
                    }

                    if (this.obj_to_null(e.uniq)) {
                        this.uniq_call = e.uniq
                    }

                }
                this.show = true;
            });
            EventBus.$on('close_u_filter', e => {
                this.$store.dispatch('users_filter/CLEAN');
                setTimeout(() =>  this.show = false, 500);
            });

        },

        methods : {

            close() {
              this.show = false;
            },

            setTab(tabIndex) {
                this.tabIndex = tabIndex;
            },

            close_filter () {
                this.show_action = true;

                if(this.active_users.length > 0) {
                    let send = JSON.parse(JSON.stringify( this.active_users));
                    EventBus.$emit('selected_users',{
                        users: send,
                        uniq:this.uniq_call
                    });
                }
                else {
                    EventBus.$emit('selected_users',{
                        users: [],
                        uniq:this.uniq_call
                    });
                }

                this.$store.dispatch('users_filter/CLEAN');
                setTimeout(() =>  this.show_action = false, 500);
            },
        },
        
        computed: {
            ...mapFields([
                'active_users'
            ]),
        },
        
        
        watch: {
            exclude(value) {
                console.log(value);
            }
        },
    }
</script>

<style scoped>
    #panel_user_list {
        height:100vh;
    }
</style>
